var exports = {
  "I": "x31de4314--04cc24--select-popup",
};

module.exports = exports;
